import { render, staticRenderFns } from "./tileTitle.vue?vue&type=template&id=963b32be&scoped=true&"
import script from "./tileTitle.vue?vue&type=script&lang=js&"
export * from "./tileTitle.vue?vue&type=script&lang=js&"
import style0 from "./tileTitle.vue?vue&type=style&index=0&id=963b32be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b32be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('963b32be')) {
      api.createRecord('963b32be', component.options)
    } else {
      api.reload('963b32be', component.options)
    }
    module.hot.accept("./tileTitle.vue?vue&type=template&id=963b32be&scoped=true&", function () {
      api.rerender('963b32be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/tileTitle/tileTitle.vue"
export default component.exports